var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3 0.500002L24.3005 0.500001C24.8706 0.499386 25.4254 0.741356 25.8409 1.18588C26.2574 1.63145 26.498 2.24342 26.5 2.88914C26.5 2.88936 26.5 2.88958 26.5 2.8898L26.5 20.3116C26.5 21.66 25.4816 22.7 24.3 22.7H16.7722C15.7285 22.7 14.7086 23.0126 13.844 23.5974L9.60801 26.463C8.60442 27.1419 7.25 26.4229 7.25 25.2112C7.25 23.8243 6.12568 22.7 4.73876 22.7H2.7C1.51842 22.7 0.5 21.66 0.5 20.3116V2.8884C0.5 1.54004 1.51842 0.500001 2.7 0.500001L24.3 0.500002ZM14.75 16.45C15.827 16.45 16.7 15.577 16.7 14.5C16.7 13.423 15.827 12.55 14.75 12.55H8.2C7.12304 12.55 6.25 13.423 6.25 14.5C6.25 15.577 7.12304 16.45 8.2 16.45H14.75ZM18.8 10.65C19.877 10.65 20.75 9.77696 20.75 8.7C20.75 7.62304 19.877 6.75 18.8 6.75H8.2C7.12305 6.75 6.25 7.62304 6.25 8.7C6.25 9.77696 7.12305 10.65 8.2 10.65H18.8Z",
    fill: "#FFEA32",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/Comment.794dd3f977a1e0cecdd82df78b91e6f0.svg";
export { ForwardRef as ReactComponent };